import AccountsReceivableList from './AccountsReceivableListContainer';
export default AccountsReceivableList;
